<template>
  <div>
    <b-container class="container card">
      <div id="search" v-if="search" class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-search"></i>
            <span>بحث</span>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="form row card-search">
              <div class="form-group col-md-3">
                <label for="">كود الحى</label>
                <input type="text" class="form-control" v-model="s_id" />
              </div>
              <div class="form-group col-md-3">
                <label for="">المدينة</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_cID"
                >
                  <option
                    v-for="city in cities"
                    :value="city.id"
                    :key="city.id"
                  >
                    <span> {{ city.cName }} </span>
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label for="">الحى</label>
                <input type="text" class="form-control" v-model="s_dName" />
              </div>

            
              <div class="form-group col-md-3 p-4">
                <button @click="clear" class="btn btn-danger">
                  الغاء البحث
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- **************************** crud  **********************************-->
      <div id="crud" v-if="crud" class="card">
        <div v-if="add" class="card-header bg-primary ">
          <div>
            <i class="fa fa-plus"></i>
            <span>إضافة</span>
          </div>
        </div>
        <div v-if="edit" class="card-header bg-warning">
          <div>
            <i class="fa fa-pen-nib"></i>
            <span>تعديل</span>
          </div>
        </div>
        <form action="" @submit.prevent="submit">
          <div class="card-body">
            <div class="container">
              <div class="form row card-search">
                <div class="form-group col-md-3">
                  <label for="">كود االحى</label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model.trim="$v.id.$model"
                    :class="{
                      'is-invalid': $v.id.$error,
                      'is-valid': !$v.id.$invalid,
                    }"
                  />
                  <div class="invalid-feedback"></div>
                </div>
                 <div class="form-group col-md-3">
                  <label for="">المدينة
                  </label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.cID.$model"
                    :class="{
                      'is-invalid': $v.cID.$error,
                      'is-valid': !$v.cID.$invalid,
                    }"
                  >
                    <option
                      v-for="city in cities"
                      :value="city.id"
                      :key="city.id"
                    >
                      <span> {{ city.cName }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.cID.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">الحى</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.dName.$model"
                    :class="{
                      'is-invalid': $v.dName.$error,
                      'is-valid': !$v.dName.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.dName.required">هذا الحقل مطلوب</span>
                    <span v-if="!$v.dName.minLength"
                      >يجب ان يحتوى على الاقل على{{
                        $v.dName.$params.minLength.min
                      }}</span
                    >
                    <span v-if="!$v.dName.maxLength"
                      >اقصى عدد مسموح {{ $v.dName.$params.maxLength.max }} حرف
                    </span>
                  </div>
                </div>
              </div> 

              <div v-if="add" class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      style="background-color:#007bff !important;"
                      class="col-md-6 btn-primary"
                      type="submit"
                      :disabled="busy"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{addEdit}}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="cancelCrud"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
              <div v-if="edit" class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-warning"
                      type="submit"
                      :disabled="busy"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{addEdit}}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ul class="nav nav-tabs view-mode">
        <li class="nav-item ">
          <a class="nav-link active" data-toggle="tab" href="#home">
            <i class="fa fa-table"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#menu1">
            <i class="fa fa-bars"></i>
          </a>
        </li>
      </ul>
      <!-- **************************** add button **********************************-->
      <div class="m-auto">
        <b-button  v-if="c_add" @click="insert" variant="outline-primary">إضافة</b-button>
        <div class="std-count">
          <span class="text-danger">
            عدد الاحياء
          </span>
          <span> | </span>
          <span class="text-success"> {{ items.length }} </span>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane container active overflow" id="home">
          <!-- Main table element -->

          <b-table
            :busy="isBusy"
            :bordered="true"
            :no-border-collapse="true"
            show-empty
            striped
            hover
            small
            stacked="sm"
            :fields="fields"
            :current-page="currentPage"
            :per-page="10"
            :items="filtered"
            head-variant="dark"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            sort-icon-left
          >
            <template v-slot:head(id) style="background-color:red;">
              <span class="text-info">كود الحى</span>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> جارى التحميل ... </strong>
              </div>
            </template>
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'id' ? '20px' : '20px' }"
              />
            </template>
            <template slot="top-row" slot-scope="{ fields }">
              <td v-for="field in fields" :key="field.key">
                <input
                  v-model="filters[field.key]"
                  :placeholder="field.label"
                />
              </td>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
               v-if="c_update"
                size="sm"
                @click="update(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-warning"
              >
                تعديل
              </b-button>
              <b-button
               v-if="c_delete"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-danger"
              >
                حذف
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col sm="7" md="6" class="m-auto">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class=""
              ></b-pagination>
            </b-col>
          </b-row>
          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center">
              <b-row>
                <div class="card-body">
                  <span>
                    هل انت متأكد من حذف الحى رقم <span class="text-primary">{{ delitem.id }}</span> ؟
                  </span>
                  <span class="text-dark">{{ delitem.boardNum }}</span>
                </div>
              </b-row>
              <div class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-danger"
                      :disabled="busy"
                      @click="remove(delitem)"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ btnDelMessage }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </b-modal>
          <!-- Add/update -->
          <b-modal
            id="updateModal"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center"></div>
          </b-modal>
        </div>
        <div class="tab-pane container fade" id="menu1">
          <div class="container">
            <div class="row">
              <div class="col-md-3" v-for="item in items" :key="item.id">
                <div class="itm card">
                  <div class="card-header">
                    <span>كود الحى</span>
                    <span> | </span>
                    <span class="text-warning"> {{ item.id }} </span>
                  </div>
                  <table>
                    <tr>
                      <td>المدينة</td>
                      <td>|</td>
                      <td>{{ item.cName }}</td>
                    </tr>
                    <tr>
                      <td>الحى</td>
                      <td>|</td>
                      <td>{{ item.dName }}</td>
                    </tr>
                  </table>

                  <div class="card-footer m-auto">
                    <b-button
                     v-if="c_update"
                      size="sm"
                      class="mr-1"
                      @click="update(item)"
                      variant="outline-warning"
                    >
                      تعديل
                    </b-button>
                    <b-button
                     v-if="c_delete"
                      size="sm"
                      @click="infoDel(item.id)"
                      class="mr-1"
                      variant="outline-danger"
                    >
                      حذف
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import indexLayout from "../../layouts/indexLayout.vue";
export default {
  name: "districts",
  data() {
    return {
      s_id: null,
      s_cID: null,
      s_dName: null,
      id: null,
      cID: null,
      dName:null,


      /* خاص بالبحث والاضافة والتعديل */ 
      search: true,
      crud: false,
      add: false,
      edit: false,
      isBusy: true,
      busy: false,
      addEdit:null,
      btnDelMessage: "حذف",
      items: [],
      delitem: "",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
         /*check role */
c_add:false,
c_update:false,
c_delete:false,

/*check end */
      fields: [
        {
          key: "id",
          label: "كود المدينة",
          sortable: true,
          class: "f-id",
          sortDirection: "desc",
          tdClass: "fid",
        },
        {
          key: "cName",
          label: "المدينة",
          sortable: true,
          class: "text-center",
        },{
          key: "dName",
          label: "الحى",
          sortable: true,
          class: "text-center",
        },

        { key: "actions", label: "" },
      ],
      filters: {
        id: "",
        cID: "",
        dName: "",
      
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  validations: {
    id: {},
    cID: { required },
    dName: { required, minLength: minLength(2), maxLength: maxLength(25) },
   
  },
    created(){
      this.$emit('update:layout',indexLayout)
      this.Role_check();
    },
  computed: {
    ...mapGetters({
      load: "districtMod/GET_ALLDATA",
      check : "GET_ROLES"
    }),
    ...mapState(["cities"]),

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    filtered() {
      const filtered = this.items.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key]).includes(this.filters[key])
        );
      });
      return filtered.length > 0
        ? filtered
        : [
            {
       id: "",
        cID: "",
        dName: "",
            },
          ];
    },
  },
  mounted() {
    this.getData();
 
  },
  methods: {
    ...mapActions({
      loadData: "districtMod/fetchData",
      addData: "districtMod/addData",
      updateData: "districtMod/updateData",
      deleData: "districtMod/deleteData",
    }),
    insert: function() {
      this.addEdit = "إضافة";
      this.$v.$reset();
      this.clearCrud();
      this.search = false;
      this.crud = true;
      this.add = true;
      this.edit = false;
     window.scrollTo(0, 0)

    },
    update(item) {
      this.addEdit = "تعديل";
      this.delitem = item;
      this.search = false;
      this.crud = true;
      this.add = false;
      this.edit = true;
      this.editLood();
      window.scrollTo(0, 0)

    },
  
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.delitem = item;
      this.search = true;
      this.crud = false;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    infoDel: function(id) {
      var item = this.items.find((todo) => todo.id == id);
      this.infoModal.title = item.id;
      this.delitem = item;
      this.search = true;
      this.crud = false;
this.$root.$emit("bv::show::modal", this.infoModal.id);
    },
    async remove(stdRow) {
      this.busy = true;
      await this.deleData(stdRow);
      this.btnDelMessage = "تم الحذف";
      this.busy = false;
      this.items = this.load;
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
      } else {
        var std = {
          id: this.id,
          cID : this.cID,
          dName: this.dName
        
        };
        this.busy = true;
        if (this.add == true) {
          await this.addData(std);
           var state1= this.$store.getters['districtMod/getMsg'];
         if(state1 <= 201){
          this.search = true;
          this.crud = false;
        
          this.addEdit = "تم الاضافة";
         }else{
           this.addEdit = "خطأ";
         }
         
        }
        if (this.edit == true) {
         await this.updateData(std);
         var state2= this.$store.getters['districtMod/getMsg'];
         if(state2 <= 201){
          this.search = true;
          this.crud = false;
       
          this.addEdit = "تم التعديل";
         }else{
           this.addEdit = "خطأ";
         }
               
        }

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.busy = false;
          this.submitStatus = "تم الحفظ";
        }, 500);
      }
    },cancelCrud() {
      this.search = true;
      this.crud = false;
 
    },
    hideModal() {
      this.search = true;
      this.crud = false;
      
      this.$root.$emit("bv::hide::modal", this.infoModal.id);
    },
    clearCrud() {
      this.s_id = "";
      this.s_cID = "";
      this.s_dName = "";
      this.id = "";
      this.cID = "";
      this.dName = null;
    },
    editLood() {
      this.s_id = "";
      this.s_cID = "";
      this.s_dName = "";
      this.id = this.delitem.id;
      this.cID = this.delitem.cID;
      this.dName = this.delitem.dName;

    },
    async getData() {
      if (this.load.length > 0) {
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;
      } else {
        await this.$store.dispatch("districtMod/fetchData");
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;
      }
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Cfilter() {
      this.items = this.load;
      this.items = this.items.filter((t) =>
        t.id.toString().includes(this.s_id)
      );

      this.items = this.items.filter((t) =>
        t.cID.toString().includes(this.s_cID)
      );
      this.items = this.items.filter((t) =>
        t.dName.toString().includes(this.s_dName)
      );

    
    },
      Role_check(){
this.c_add =this.check.district_add ==1 ? true : false;
this.c_update =this.check.district_update ==1 ? true : false;
this.c_delete =this.check.district_delete ==1 ? true : false;
},
    clear() {
      this.s_id = "";
      this.s_cID = "";
      this.s_dName = "";
    }},
  watch: {
    s_id: function() {
      this.Cfilter();
    },
     s_cID: function() {
      this.Cfilter();
    },
    s_dName: function() {
      this.Cfilter();
    }
  }
}
</script>
<style lang="scss" scoped>
.b-table-top-row > td:last-child {
  visibility: hidden;
}
.nav-link.active {
  background-color: #ddab2b !important;
}
.fid {
  background-color: #ddab2b;
}
.itm {
  margin: 10px 0px;
  box-shadow: 0px 0px 6px 1px black;
  -moz-box-shadow: 0px 0px 6px 1px black;
  -o-box-shadow: 0px 0px 6px 1px black;
  -webkit-box-shadow: 0px 0px 6px 1px black;
}
.dropdown-menu {
  z-index: 1600 !important; /* has to be larger than 1050 */
}
</style>
